import { render, staticRenderFns } from "./Kb6.vue?vue&type=template&id=370a1809&scoped=true&"
import script from "./Kb6.vue?vue&type=script&lang=js&"
export * from "./Kb6.vue?vue&type=script&lang=js&"
import style0 from "./Kb6.vue?vue&type=style&index=0&id=370a1809&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370a1809",
  null
  
)

export default component.exports